var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLutealUnconfirmedClock = function SvgLutealUnconfirmedClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 12.5a1 1 0 0 1 1 1v2.346l1.861.721a1 1 0 0 1-.722 1.866L15.5 17.216V13.5a1 1 0 0 1 1-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 9a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15m0 2a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.278.476a.785.785 0 0 1 1.444 0l1.336 3.123a.785.785 0 0 0 1.013.42l3.154-1.263a.784.784 0 0 1 1.02 1.02L15.98 6.929a1 1 0 0 0-.03.088 9.5 9.5 0 0 0-8.934 8.934 1 1 0 0 0-.088.03l-3.154 1.263a.784.784 0 0 1-1.02-1.02l1.264-3.153a.785.785 0 0 0-.42-1.013L.476 10.722a.785.785 0 0 1 0-1.444l3.123-1.335a.785.785 0 0 0 .42-1.014L2.756 3.776a.784.784 0 0 1 1.02-1.02l3.153 1.263a.785.785 0 0 0 1.013-.42z"
  })));
};
export default SvgLutealUnconfirmedClock;